import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type Props = {
	value: string | number | null;
	currencySign?: string;
	variant?: "bodyStrong" | "bodyMedium";
	suffix?: string;
};

export const CurrencyAmount: FC<Props> = ({
	value,
	currencySign,
	variant = "bodyStrong",
	suffix,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	if (value === null || value === "") {
		return null;
	}

	const sign = currencySign ?? t(Resources.Common.CurrencySign);
	const formatted = moneyFormatter(value, "").trim();

	return (
		<Typography variant={variant} color={theme.palette.grey[900]} tabular>
			{formatted}
			<Typography component="span" variant="button" sx={{ opacity: 0.5 }}>
				{" "}
				{sign}
				{suffix}
			</Typography>
		</Typography>
	);
};
